import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { ContentBlock } from '../../models';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { SwiperOptions, Swiper, SwiperModule } from 'swiper/types';
import { Autoplay, FreeMode, EffectCoverflow } from 'swiper/modules';
import { Team } from '../../models/team.model';
import { SwiperContainer } from 'swiper/element';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';

@Component({
  selector: 'app-content-block-teamv2',
  templateUrl: './content-block-teamv2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockTeamv2Component extends ContentBlockBaseComponent implements AfterViewInit {
  cd = inject(ChangeDetectorRef);

  swiperIndex$ = signal(0);

  @ViewChild('swiper') swiperEl?: ElementRef<SwiperContainer>;

  override ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  initSwiper(): void {
    const that = this;
    const params: SwiperOptions = {
      modules: [Autoplay, EffectCoverflow],
      // injectStylesUrls: ['swiper/scss/free-mode'],
      effect: 'coverflow',
      coverflowEffect: {
        // rotate: 30,
        //slideShadows: false,
        // stretch: 20,
        rotate: 20, // Draaiing van de dia's
        stretch: 40, // Hoeveel de dia's worden uitgerekt (0 betekent geen rek)
        depth: 600, // Diepte van de stapel dia's
      },
      centeredSlides: true,
      loop: true,
      //speed: 800,
      autoplay: false,
      //loopedSlides: this.block.teams?.length || 10,

      // autoplay: {
      //   stopOnLastSlide: false,
      //   delay: 4000,
      // },

      breakpoints: {
        0: {
          slidesPerView: 1,
          coverflowEffect: {
            // rotate: 30,
            slideShadows: false,
            // stretch: 20,
            rotate: 30, // Draaiing van de dia's
            stretch: 0, // Hoeveel de dia's worden uitgerekt (0 betekent geen rek)
            depth: 600, // Diepte van de stapel dia's
          },
        },
        800: {
          slidesPerView: 1,
          spaceBetween: 0,
          coverflowEffect: {
            // rotate: 30,
            slideShadows: false,
            // stretch: 20,
            rotate: 10, // Draaiing van de dia's
            stretch: 180, // Hoeveel de dia's worden uitgerekt (0 betekent geen rek)
            depth: 640, // Diepte van de stapel dia's
          },
        },
        1600: {
          slidesPerView: 1,
          spaceBetween: 0,
          coverflowEffect: {
            // rotate: 30,
            slideShadows: false,
            // stretch: 20,
            rotate: 10, // Draaiing van de dia's
            stretch: 500, // Hoeveel de dia's worden uitgerekt (0 betekent geen rek)
            depth: 800, // Diepte van de stapel dia's
          },
        },
      },
      on: {
        realIndexChange: function (i) {
          that.swiperIndex$.set(i.realIndex);
        },
      },

      // freeMode: true,
    };

    if (this.swiperEl?.nativeElement) {
      Object.assign(this.swiperEl.nativeElement, params);
      this.swiperEl.nativeElement.initialize();

      const swiper = this.swiperEl?.nativeElement?.swiper;
      swiper.loopDestroy();
      swiper.loopCreate();
    }
  }

  slideNext() {
    this.swiperEl?.nativeElement.swiper.autoplay.pause;

    const swiper = this.swiperEl?.nativeElement.swiper;
    if (!swiper) {
      return;
    }

    //Workaround safari bug nextSlide() and prevSlide() not working with loop enabled
    if (swiper.activeIndex === swiper.slides.length - 1) {
      // If currently on the last slide, reset to the first slide
      swiper.slideTo(0);
    } else {
      // Otherwise, advance to the next slide
      swiper.slideTo(swiper.activeIndex + 1);
    }
  }

  trackByFn(index: number, block: Team) {
    return block.id;
  }

  get slides() {
    if (!this.block?.teams) return [];
    return [...this.block?.teams, ...this.block?.teams];
  }
}
